export const width = 136;
export const height = 116;
export default __webpack_public_path__ + "static/service-24-7-rafiki.8cb2b5f5.svg";